// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content-modification {
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-content-modification h2 {
  margin-top: 0;
  margin-bottom: 24px;
  color: #333;
}

.modal-content-modification .form-group {
  margin-bottom: 16px;
}

.modal-content-modification label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.modal-content-modification input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.modal-content-modification .input-inactif {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.modal-content-modification .input-error {
  border-color: #dc3545;
}

.modal-content-modification .error-message {
  color: #dc3545;
  font-size: 0.85rem;
  margin-top: 4px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}`, "",{"version":3,"sources":["webpack://./src/composants/ModificationModal/ModificationModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content-modification {\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-content-modification h2 {\n  margin-top: 0;\n  margin-bottom: 24px;\n  color: #333;\n}\n\n.modal-content-modification .form-group {\n  margin-bottom: 16px;\n}\n\n.modal-content-modification label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.modal-content-modification input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.modal-content-modification .input-inactif {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.modal-content-modification .input-error {\n  border-color: #dc3545;\n}\n\n.modal-content-modification .error-message {\n  color: #dc3545;\n  font-size: 0.85rem;\n  margin-top: 4px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
